import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import { Section, SectionHeading, FeatureCard, FeatureImage } from '../../styles';
import {
  FeaturesContentContainer,
  FeaturesSubtext,
  FeaturesGridWrapper,
  FeatureCardSubtext,
  FeaturesCtaWrapper,
  FeaturesCTAButton,
} from './styles';
import { features } from '../../constants';

const FeaturesSection = () => {
  const navigate = useNavigate();

  return (
    <Section>
      <FeaturesContentContainer>
        <SectionHeading>Why Choose Nirva?</SectionHeading>
        <FeaturesSubtext>Expert care. Honest connection. Always confidential.</FeaturesSubtext>

        <FeaturesGridWrapper>
          <Grid container spacing={'23px'} rowSpacing={'23px'} justifyContent="center">
            {features.map((feature, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <FeatureCard>
                  <FeatureImage src={feature.icon} alt={feature.title} />
                  <FeatureCardSubtext>{feature.title}</FeatureCardSubtext>
                </FeatureCard>
              </Grid>
            ))}
          </Grid>
        </FeaturesGridWrapper>

        <FeaturesCtaWrapper>
          <FeaturesCTAButton onClick={() => navigate('/services')} text="Explore Our Services" />
        </FeaturesCtaWrapper>
      </FeaturesContentContainer>
    </Section>
  );
};

export default FeaturesSection;
